import httpService from '@/modules/common/services/httpService';

const bulkRoute = 'v3/clients/client_settings/bulk';

const bulkUpdate = async (clientSettings) => httpService
  .put(bulkRoute, { client_settings: clientSettings })
  .then((res) => res.data?.data);

export default {
  bulkUpdate,
};
